import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_VAT_PREFIX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

// The buyer doesn't need to know which VAT rate (0%, 5%, 20%) was used -
// only the amount, so the label is a plain "VAT" regardless of rate.
const LineItemVATMaybe = props => {
  const { lineItems, intl } = props;

  const vatLineItem = lineItems.find(
    item => item.code.startsWith(LINE_ITEM_VAT_PREFIX) && !item.reversal
  );

  return vatLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.vat" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, vatLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemVATMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemVATMaybe;
